export const setupDataLayer = () => {
  if (!window.dataLayer) window.dataLayer = [];
};
